import {
  MESSAGE_SUCCES,
  MESSAGE_INFO,
  MESSAGE_ERROR,
} from "../actions/types";
import { v4 as uuid } from 'uuid';

export default function (state = "", action) {
  const { type, message = "", header = "" } = action;
  switch (type) {
    case MESSAGE_SUCCES:
	case MESSAGE_INFO:
	case MESSAGE_ERROR:
		var messageKey = uuid().slice(0,8);
      return {
		message_id: messageKey,
		header: header,
        message: message,
		type: type,
		show: true
      };
    default:
      return false;
  }
}